import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getCorporateFinancialProductsSlice = createSlice({
  name: "getCorporateFinancialProducts",
  initialState,
  reducers: {
    getCorporateFinancialProductsStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getCorporateFinancialProductsSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getCorporateFinancialProductsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getCorporateFinancialProductsStart,
  getCorporateFinancialProductsSuccess,
  getCorporateFinancialProductsFailure,
  clearError,
  clearMessage,
} = getCorporateFinancialProductsSlice.actions;

export default getCorporateFinancialProductsSlice.reducer;
